<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
          font-size: 13px;
        "
      >
        银行到账认领
      </ul>
      <div style="flex: 1; overflow: auto; padding: 10px">
        <div style="font-weight: 600; font-size: 13px">基本信息</div>
        <el-descriptions
          :column="4"
          border
          style="overflow-x: auto; margin-top: 10px"
          class="desc-label-nowrap"
        >
          <el-descriptions-item label="到账ID" label-align="right">
            <div style="width: 200px">
              {{ state.model.id }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="状态" label-align="right">
            <div style="width: 200px">
              <component
                :is="
                  $statusFormat2(
                    'bankReceived_collected_status',
                    state.model.collected_status,
                  )
                "
              />
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="到账银行" label-align="right">
            <div style="width: 200px">
              {{ state.model.bank_account?.opening_bank || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="付款银行" label-align="right">
            <div style="width: 200px">
              {{ state.model.payment_name
              }}<text v-if="state.model.payment_bank" style="color: #a2a2a2">
                {{ "/" + state.model.payment_bank }}
              </text>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="摘要信息" label-align="right">
            <div style="width: 200px">
              {{ state.model.summary || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="到账金额" label-align="right">
            <div style="width: 200px">
              {{ $priceFormat(state.model.received_amount) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="到账时间" label-align="right">
            <div style="width: 200px">
              {{ state.model.received_date || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="实际到账金额" label-align="right">
            <div style="width: 200px">
              <c_money :value="parseFloat(state.model.real_received_amount)" />
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="手续费" label-align="right">
            <div style="width: 200px">
              {{ $priceFormat(state.model?.service_fee) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="已认领金额" label-align="right">
            <div style="width: 200px">
              {{ $priceFormat(state.model?.collected_amount) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="认领中金额" label-align="right">
            <div style="width: 200px">
              {{ $priceFormat(state.model?.collecting_amount) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="未认领金额" label-align="right">
            <div style="width: 200px; display: flex">
              {{ $priceFormat(state.model?.uncollected_amount) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="创建人" label-align="right" :span="2">
            <div style="width: 400px; display: flex">
              {{ state.model.add_admin_name }}
              <text v-if="state.model.add_department_name">
                {{ "/" + state.model.add_department_name }}
              </text>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间" label-align="right">
            <div style="width: 200px; display: flex">
              {{ state.model.create_time }}
            </div>
          </el-descriptions-item>
        </el-descriptions>

        <template v-if="state.model.collected_status != 2">
          <div style="font-weight: 600; font-size: 13px; margin-top: 10px">
            操作认领
          </div>
          <el-form
            :model="state.rlModel"
            label-width="auto"
            style="margin-top: 10px"
            ref="formDom"
            :disabled="!state.rlModel?.customer_id"
          >
            <ul style="display: flex">
              <el-form-item
                label="客户"
                prop="customer_id"
                :rules="[
                  {
                    required: true,
                    message: '请选择认领客户',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  v-model="state.rlModel.customer_id"
                  style="width: 400px"
                  @change="onCustomerChange"
                  disabled
                >
                  <el-option
                    v-for="item in state.customerData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                  <template #footer>
                    <el-button size="small" @click="onLoadCustomer()">
                      刷新
                    </el-button>
                  </template>
                </el-select>
                <text
                  v-if="state.rlModel.customer_id"
                  style="margin-left: 3px; color: #1e90ff; cursor: pointer"
                  @click="onCopy"
                  >复制客户</text
                >
              </el-form-item>
              <el-form-item label="项目编码" style="width: 500px">
                <el-input v-model="state.rlModel.project_no"></el-input>
              </el-form-item>
            </ul>
            <el-form-item
              style="
                border-bottom: 1px solid #f6f6f6;
                margin-bottom: 30px;
                padding-bottom: 30px;
              "
            >
              <template #label>
                <div
                  style="display: flex; align-items: center; padding-left: 20px"
                >
                  <text>认领说明</text>
                  <el-tooltip
                    effect="dark"
                    content="该项有内容时，后续添加的认领用途的分项说明系统将默认填入该项的内容，也可自行编辑"
                    placement="top-start"
                  >
                    <el-icon style="cursor: pointer">
                      <QuestionFilled />
                    </el-icon>
                  </el-tooltip>
                </div>
              </template>
              <el-input v-model="state.remark" @blur="onRemarkBlur(false)">
                <template #suffix>
                  <el-tooltip
                    effect="dark"
                    content="该项有内容时，点击该按钮，系统将覆盖所有用途的说明，无论分项用途说明是否已填写"
                    placement="top-start"
                  >
                    <el-button size="small" @click="onRemarkBlur(true)">
                      强制覆盖
                    </el-button>
                  </el-tooltip>
                </template>
              </el-input>
            </el-form-item>
            <div
              v-for="(model, index) in state.rlModel.bank_received_data"
              :key="model"
            >
              <div>
                <div style="display: flex; align-items: center">
                  <el-form-item label="日期">
                    <el-date-picker
                      v-model="model.month"
                      type="month"
                      format="YYYY年M月"
                      value-format="YYYY-MM"
                      style="width: 160px"
                      @change="onRowChange(model)"
                    />
                  </el-form-item>
                  <el-form-item
                    label="用途"
                    prop="model.bank_received_type"
                    :rules="[
                      {
                        required: true,
                        validator: (rule, value, callback) => {
                          if (model.bank_received_type) callback();
                          else callback(new Error('请选择认领用途'));
                        },
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      v-model="model.bank_received_type"
                      style="width: 150px"
                      @change="onTypeChange($event, model)"
                    >
                      <el-option
                        v-for="item in state.typeData"
                        :key="item"
                        :label="item.name"
                        :value="item.name"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="金额">
                    <el-input-number
                      v-model="model.collect_amount"
                      :controls="false"
                      class="number-input-left number-input-suffix"
                      :precision="2"
                      suffix="元"
                      :min="
                        model.bank_received_type != '其他'
                          ? 0
                          : Number.MIN_SAFE_INTEGER
                      "
                      style="width: 150px"
                      @focus="$onFocus"
                      @change="onRowChange(model)"
                    ></el-input-number>
                  </el-form-item>
                  <el-form-item
                    label="工资表"
                    prop="model.payroll_id"
                    v-if="
                      ['工资', '个税', '服务费'].includes(
                        model.bank_received_type,
                      )
                    "
                    style="flex: 1"
                    :rules="[
                      {
                        required:
                          ['工资', '个税'].includes(model.bank_received_type) &&
                          model.collect_amount > 0,
                        validator: (rule, value, callback) => {
                          if (
                            ['工资', '个税'].includes(
                              model.bank_received_type,
                            ) &&
                            model.collect_amount > 0 &&
                            !model.payroll_id
                          )
                            callback(new Error('请选择工资表'));
                          else callback();
                        },
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      v-model="model.payroll_id"
                      @change="onPayrollChange($event, model)"
                    >
                      <el-option
                        v-for="item in state.payroll_data"
                        :key="item"
                        :label="`${item.order_id}_${item.name}_${item.settle_amount}`"
                        :value="item.id"
                      >
                        <div style="display: flex; align-items: center">
                          <li style="flex: 1">
                            <text style="color: #1e90ff">
                              ({{ item.order_id }})
                            </text>
                            <text>{{ item.name }}</text>
                          </li>
                          <div
                            style="
                              width: 200px;
                              display: flex;
                              column-gap: 10px;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                flex: 1;
                                overflow: hidden;
                                display: flex;
                                align-items: center;
                              "
                            >
                              <span
                                style="
                                  color: #fff;
                                  font-size: 11px;
                                  background-color: #1e90ff;
                                  border-radius: 2px;
                                  margin-right: 3px;
                                  cursor: pointer;
                                  width: 15px;
                                  height: 15px;
                                  line-height: 15px;
                                  text-align: center;
                                "
                                title="结算金额"
                                >结
                              </span>
                              <li
                                style="
                                  flex: 1;
                                  overflow: hidden;
                                  color: #1e90ff;
                                "
                              >
                                {{ item.settle_amount }}
                              </li>
                            </div>
                            <div
                              style="
                                flex: 1;
                                overflow: hidden;
                                display: flex;
                                align-items: center;
                              "
                            >
                              <span
                                style="
                                  color: #fff;
                                  font-size: 11px;
                                  background-color: #f00;
                                  border-radius: 2px;
                                  margin-right: 3px;
                                  cursor: pointer;
                                  width: 15px;
                                  height: 15px;
                                  line-height: 15px;
                                  text-align: center;
                                "
                                title="欠款金额"
                                >欠
                              </span>
                              <li
                                style="flex: 1; overflow: hidden; color: #f00"
                              >
                                {{ item.arrearage_amount }}
                              </li>
                            </div>
                          </div>
                        </div>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <li style="flex: 1" v-else></li>
                  <el-button
                    type="primary"
                    link
                    size="small"
                    icon="plus"
                    style="margin-bottom: 22px"
                    @click="
                      state.rlModel.bank_received_data.splice(index + 1, 0, {
                        collect_remark: state.remark,
                      })
                    "
                  >
                    添加
                  </el-button>
                  <el-button
                    type="danger"
                    link
                    size="small"
                    icon="delete"
                    style="margin-bottom: 22px; margin-left: 0"
                    @click="state.rlModel.bank_received_data.splice(index, 1)"
                    >删除</el-button
                  >
                </div>
                <el-form-item
                  label="说明"
                  prop="model.collect_remark"
                  :rules="[
                    {
                      required:
                        model.collect_amount > 0 &&
                        model.bank_received_type == '其他',
                      validator: (rule, value, callback) => {
                        if (
                          model.collect_amount > 0 &&
                          model.bank_received_type == '其他' &&
                          !model.collect_remark
                        )
                          callback(new Error('请填写认领说明'));
                        else callback();
                      },
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input v-model="model.collect_remark" size="large" />
                </el-form-item>
              </div>
            </div>
            <ul
              style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
              "
            >
              合计：
              <c_money
                :value="state.totalAmount"
                bold
                size="30"
                :prefix="false"
                style="margin-right: 100px"
              />
              <el-button type="info" @click="onClose">关闭</el-button>
              <el-button type="primary" @click="onSubmit(0)"
                >确认认领</el-button
              >
              <el-button type="success" @click="onSubmit(1)"
                >认领并同步创建子账户</el-button
              >
            </ul>
          </el-form>
        </template>
        <template v-if="state.yrlData.length > 0">
          <div style="margin-top: 10px; display: flex; align-items: center">
            <text style="font-weight: 600; font-size: 13px">认领记录</text>
            <div
              style="
                flex: 1;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                color: #a2a2a2;
                font-size: var(--tab-group-second-font-size);
              "
              v-html="
                Object.keys(state.model.collected_amount_detail?.collected)
                  .map(
                    (key) =>
                      `${key}: <text style='color:#ffa500;margin-right:5px;font-size:16px'>${$priceFormat(
                        state.model.collected_amount_detail?.collected[key],
                      )}</text>`,
                  )
                  .join(' ')
              "
            ></div>
          </div>
          <el-table :data="state.yrlData" style="margin-top: 10px">
            <el-table-column
              fixed
              label="序号"
              width="50"
              type="index"
              align="center"
            />
            <el-table-column
              label="状态"
              prop="status"
              sortable="status"
              :formatter="
                (row, column, cellValue) =>
                  $statusFormat2('bankcollected_status', cellValue)
              "
            />
            <el-table-column label="认领用途" prop="bank_received_type" />
            <el-table-column
              label="认领金额"
              prop="collect_amount"
              sortable="collect_amount"
              :formatter="$tab_MoneyFormat"
            />
            <el-table-column
              label="认领单号"
              prop="order_id"
              :formatter="$tab_TextFormat"
            />
            <el-table-column
              label="认领人"
              prop="add_admin_name"
              :formatter="
                (row) => row.add_admin_name + '/' + row.add_department_name
              "
            />
            <el-table-column
              label="认领时间"
              prop="create_time"
              :formatter="$tab_TextFormat"
            />
            <el-table-column
              label="认领说明"
              prop="collect_remark"
              :formatter="$tab_TextFormat"
            />
            <el-table-column
              label="更新人"
              :formatter="
                (row) =>
                  row.add_admin_name
                    ? row.add_admin_name + '/' + row.add_department_name
                    : '-'
              "
            />
            <el-table-column
              label="更新时间"
              prop="update_time"
              :formatter="$tab_TextFormat"
            />
          </el-table>
        </template>
      </div>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="编辑员工"
      @close="state.showEdit = false"
    >
      <c_CustomerInfo
        @close="
          state.showEdit = false;
          onLoad();
        "
        :id="props.data?.id"
      ></c_CustomerInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive, ref, getCurrentInstance } from "vue";
import {
  bankcollected_detail,
  bankcollected_rllist,
  bankcollected_add,
  bankcollected_getpayroll,
} from "@/http/bankcollected";
import { bankcollected_receivedtype_select } from "@/http/dictionary";
import { ElMessageBox, ElMessage, dayjs } from "element-plus";
import { data_customer_select } from "@/http/data";
import store from "@/store";

export default {
  props: {
    data: Object,
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const state = reactive({
      model: {},
      rlzData: [],
      yrlData: [],
      rlModel: {
        bank_received_data: [
          {
            bank_received_type: "工资",
          },
          {
            bank_received_type: "个税",
          },
          {
            bank_received_type: "服务费",
          },
          {
            bank_received_type: "社保",
          },
          {
            bank_received_type: "公积金",
          },
        ],
      },
    });
    onMounted(() => {
      state.rlModel.bank_received_id = props.data?.id;
      state.rlModel.customer_id = props.data?.customer_id;
      state.customer_name = props.data?.customer_name;

      bankcollected_detail(props.data?.id).then((res) => {
        if (res.status == 200) {
          state.model = res.data.data;
          if (state.model?.customer_id) {
            state.customer = { id: state.model.customer_id };
            state.customer_name = state.model.customer_name;
            state.rlModel.customer_id = state.model.customer_id;
          }

          // if (state.model.customer_id)
          //   state.rlModel.customer_id = state.model.customer_id;

          onLoadPayroll();
        }
      });

      bankcollected_rllist(props.data.id).then((res) => {
        if (res.status == 200) {
          state.yrlData = res.data.data?.list;
        }
      });

      bankcollected_receivedtype_select().then((res) => {
        if (res.status == 200) state.typeData = res.data.data;
      });

      onLoadCustomer();
    });

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    const onCustomerChange = () => {
      state.rlModel.bank_received_data = [
        {
          bank_received_type: "工资",
        },
        {
          bank_received_type: "个税",
        },
        {
          bank_received_type: "服务费",
        },
        {
          bank_received_type: "社保",
        },
        {
          bank_received_type: "公积金",
        },
      ];
      onLoadPayroll();
    };

    const onTypeChange = (value, model) => {
      if (value == "工资") {
        onLoadPayroll();
      } else {
        delete model.payroll_id;
      }
      onRowChange(model, true);
    };

    const onLoadPayroll = () => {
      bankcollected_getpayroll({ customer_id: state.rlModel.customer_id }).then(
        (res) => {
          if (res.status == 200) {
            state.payroll_data = res.data.data?.list;
            const payroll_id = props.data.payroll_id;
            if (state.payroll_data.some((w) => w.id == payroll_id))
              state.rlModel.payroll_id = props.data.payroll_id;
          }
        },
      );
    };

    const onPayrollChange = (e, model) => {
      const payroll = state.payroll_data.find((w) => w.id == e);
      switch (model.bank_received_type) {
        case "工资":
          model.collect_amount = parseFloat(payroll.arrearage_amount);
          break;
        case "个税":
          model.collect_amount = parseFloat(
            payroll.personal_income_tax || payroll.company_income_tax,
          );
          break;
        case "服务费":
          model.collect_amount = parseFloat(
            payroll.withhold_service_fee || payroll.standard_service_fee,
          );
          break;
        default:
          break;
      }
      onRowChange(model, true);
    };

    const onSubmit = (is_add_customer_subaccount) => {
      formDom.value.validate((valid) => {
        if (valid) {
          const unamounts = state.rlModel.bank_received_data.filter(
            (w) => typeof w.collect_amount !== "number",
          );

          if (unamounts.length == state.rlModel.bank_received_data?.length) {
            ElMessage({
              type: "warning",
              message: "请至少填写一项认领用途的认领金额！",
              grouping: true,
            });
            return false;
          }

          const totalAmount = state.rlModel.bank_received_data.reduce(
            (acc, cur) => {
              return (acc +=
                typeof cur.collect_amount === "number"
                  ? parseFloat(cur.collect_amount)
                  : 0);
            },
            0,
          );

          if (
            parseFloat(totalAmount.toFixed(2)) >
            parseFloat(state.model?.uncollected_amount || 0)
          ) {
            ElMessage.warning(`认领金额超出到款记录未认领金额！`);
            return false;
          }

          if (unamounts.length > 0) {
            ElMessageBox.confirm(
              `系统检测认领用途中<strong style='color:#1e90ff'>${unamounts
                .map((m) => m.bank_received_type)
                .join(
                  "、",
                )}</strong><strong style='color:#f00'>尚未填写认领金额</strong>，系统将自动忽略这些认领用途项，是否继续提交？`,
              "提示",
              {
                confirmButtonText: "继续提交",
                cancelButtonText: "取消",
                dangerouslyUseHTMLString: true,
                type: "warning",
              },
            ).then(() => {
              bankcollected_add({
                bank_received_id: state.rlModel.bank_received_id,
                customer_id: state.rlModel.customer_id,
                collect_remark: state.rlModel.collect_remark,
                bank_received_data: JSON.stringify(
                  state.rlModel.bank_received_data.filter(
                    (w) => typeof w.collect_amount === "number",
                  ),
                ),
                is_add_customer_subaccount,
              }).then((res) => {
                if (res.status == 200) {
                  ElMessageBox.alert(res.data.msg, "成功", {
                    type: "success",
                    confirmButtonText: "确定",
                    callback: () => {
                      onClose();
                    },
                  });
                }
              });
            });
          } else {
            bankcollected_add({
              bank_received_id: state.rlModel.bank_received_id,
              customer_id: state.rlModel.customer_id,
              collect_remark: state.rlModel.collect_remark,
              bank_received_data: JSON.stringify(
                state.rlModel.bank_received_data,
              ),
              is_add_customer_subaccount,
            }).then((res) => {
              if (res.status == 200) {
                ElMessageBox.alert(res.data.msg, "成功", {
                  type: "success",
                  confirmButtonText: "确定",
                  callback: () => {
                    onClose();
                  },
                });
              }
            });
          }
        }
      });
    };

    const onClose = () => {
      store.commit("onCloseCurrent");
      store.commit("openMenu", {
        path: "PayrollDetail",
        title: "工资表管理-" + props.data?.payroll_order_id,
        data: {
          id: props.data?.payroll_id,
        },
      });
    };

    const onRemarkBlur = (status) => {
      if (state.remark) {
        state.rlModel.bank_received_data.forEach((item) => {
          if (!item.collect_remark || status) {
            item.collect_remark = state.remark;
          }
        });
      }
    };

    const onCopy = () => {
      if (state.rlModel.customer_id) {
        ElMessage.warning("请选择客户");
        return false;
      }
      const item = state.customerData.find(
        (w) => w.id == state.rlModel.customer_id,
      );
      if (item.id) {
        proxy.$onCopy(item.name);
      }
    };

    /**
     * 行内值改变事件
     * @param row 行数据
     * @param refresh 是否刷新
     */
    const onRowChange = (row, refresh) => {
      if (!state.rlModel.customer_id) return false;

      if (refresh && row.collect_remark) {
        delete row.collect_remark;
        setTimeout(() => {
          if (row.month && row.bank_received_type && row.collect_amount) {
            row.collect_remark =
              state.customer_name +
              dayjs(row.month, "YYYY-MM").format("YYYY年M月") +
              " " +
              row.bank_received_type +
              ":" +
              row.collect_amount +
              "元，认领确认无误！";
          }
        }, 500);
      } else {
        if (row.month && row.bank_received_type && row.collect_amount) {
          row.collect_remark =
            state.customer_name +
            dayjs(row.month, "YYYY-MM").format("YYYY年M月") +
            " " +
            row.bank_received_type +
            ":" +
            row.collect_amount +
            "元，认领确认无误！";
        }
      }
      onBuildTotal();
    };

    const onBuildTotal = () => {
      state.totalAmount = state.rlModel.bank_received_data.reduce(
        (acc, cur) => {
          if (cur.bank_received_type && cur.collect_amount) {
            acc += parseFloat(cur.collect_amount);
          }
          return acc;
        },
        0,
      );
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onClose,
      onTypeChange,
      onLoadCustomer,
      onCustomerChange,
      onRemarkBlur,
      onCopy,
      onPayrollChange,
      onRowChange,
      onBuildTotal,
    };
  },
};
</script>
<style scoped lang="less">
.cus-desc {
  & > div {
    width: 25%;
  }
}
</style>
